export default __webpack_public_path__ + "static/improve-quality-of-life-accomplishment-6d-c90d4f1783933e4d1d3a38c580793a06.webp";